import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../../lib/api";
import { useAdminGuard, AdminTop } from "./AdminDashboard";

export default function SettingsForm() {
  const ready = useAdminGuard();
  const navigate = useNavigate();
  const [f, setF] = useState({ phone: "", email: "", address: "", hero_note: "", years: "" });
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (ready) api.get("/settings").then((r) => setF(r.data)); }, [ready]);
  const on = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setMsg(null);
    try { await api.post("/admin/settings", f); setMsg({ ok: true, text: "Site settings saved." }); }
    catch (err) { setMsg({ ok: false, text: errMsg(err) }); }
    setBusy(false);
  };

  if (!ready) return <div className="loading">Loading…</div>;

  return (
    <div className="adm">
      <AdminTop />
      <main className="admin-wrap narrow">
        <button className="btn-mini" onClick={() => navigate("/admin/dashboard")} style={{ width: "fit-content" }}>← Back to dashboard</button>
        <h1>Site settings</h1>
        <p className="muted" style={{ marginBottom: 20 }}>These appear across the public website — no code editing needed.</p>
        {msg && <div className={"msg " + (msg.ok ? "ok" : "err")} data-testid="settings-msg">{msg.text}</div>}
        <form onSubmit={submit} data-testid="settings-form">
          <div className="form-two">
            <label>Phone number <input type="text" value={f.phone} onChange={on("phone")} data-testid="settings-phone" /></label>
            <label>Contact email <input type="email" value={f.email} onChange={on("email")} data-testid="settings-email" /></label>
          </div>
          <label>Address / service area <input type="text" value={f.address} onChange={on("address")} data-testid="settings-address" /></label>
          <label>Hero tagline (top of homepage) <input type="text" value={f.hero_note} onChange={on("hero_note")} data-testid="settings-hero" /></label>
          <label>Founded year <input type="text" value={f.years} onChange={on("years")} data-testid="settings-years" /></label>
          <button type="submit" className="btn-primary" disabled={busy} data-testid="settings-save">{busy ? "Saving…" : "Save settings"}</button>
        </form>
      </main>
    </div>
  );
}
